"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    close: 'סגירה',
    cancel: 'ביטול',
    share: 'שיתוף',
    back: 'חזרה',
    socialShare_loMessage: 'שיתוף עם מורים בלבד',
    socialShare_urlCopyFeedback: 'קישור הועתק!',
    socialShare_socialBtn_link: 'העתקת קישור',
    socialShare_whatsapp_startTaskText: 'שותפה איתך משימה באופק',
    socialShare_whatsapp_startText: 'שותף איתך פריט מאופק',
    socialShare_socialBtn_whatsapp: 'שיתוף בוואטסאפ',
    socialShare_socialBtn_googleClassroom: 'שיתוף ב- Google Classroom',
    socialShare_socialBtn_microsoftTeams: 'שיתוף ב- Microsoft Teams'
  },
  ar: {
    close: 'إغلاق',
    cancel: 'إلغاء',
    share: 'مشاركة',
    back: 'عودة',
    socialShare_loMessage: 'مشاركة فقط مع معلّمين',
    socialShare_urlCopyFeedback: 'تمّ نسخ الرابط!',
    socialShare_socialBtn_link: 'نسخ الرابط',
    socialShare_whatsapp_startTaskText: '',
    socialShare_whatsapp_startText: 'تمّت مشاركتك بمادّة من آفاق',
    socialShare_socialBtn_whatsapp: 'مشاركة في الواتساب',
    socialShare_socialBtn_googleClassroom: 'مشاركة في - Google Classroom',
    socialShare_socialBtn_microsoftTeams: 'مشاركة في- Microsoft Teams'
  },
  en: {
    close: 'Close',
    cancel: 'Cancel',
    share: 'Share',
    back: 'Back',
    socialShare_loMessage: 'שיתוף עם מורים בלבד',
    socialShare_urlCopyFeedback: 'The link has been copied!',
    socialShare_socialBtn_link: 'Copy link',
    socialShare_whatsapp_startTaskText: 'שותפה איתך משימה באופק',
    socialShare_whatsapp_startText: 'שותף איתך פריט מאופק',
    socialShare_socialBtn_whatsapp: 'Share on WhatsApp',
    socialShare_socialBtn_googleClassroom: 'Share on Google Classroom',
    socialShare_socialBtn_microsoftTeams: 'Share on Microsoft Teams'
  }
};